const FORM_CHECKBOX_CLASS_NAME = 'form-checkbox';

export default FORM_CHECKBOX_CLASS_NAME;
